module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1044-d6ec7aca33ff115f4350e9779a5cdb72.png";